export interface RoleRef {
  id: string;
  code: string;
  name: string;
  branchId: string | null;
  expiresAt: string | null;
}

export interface UserRow {
  id: string;
  name: string;
  username: string;
  email: string | null;
  phone: string | null;
  designation: string | null;
  registrationNo: string | null;
  registrationBody?: string | null;
  nameLocal?: string | null;
  isDoctor: boolean;
  acceptsAppointments?: boolean;
  isActive: boolean;
  departmentId: string | null;
  departmentIds?: string[];
  is2faEnabled: boolean;
  cloudLoginAllowed: boolean;
  lastLoginAt: string | null;
  lockedUntil: string | null;
  defaultBranchId: string | null;
  roles: RoleRef[];
  assignmentBasis: string;
  specialty?: { id: string; name: string } | null;
  hasSignature?: boolean;
}

export interface EmployeeRecord {
  id: string;
  employeeNo: string;
  name: string;
  userId: string | null;
  cnic?: string | null;
  phone: string | null;
  email?: string | null;
  designation: string | null;
  departmentId?: string | null;
  departmentIds?: string[];
  branchId?: string | null;
  joinedAt?: string | null;
  contractType: string;
  contractEndsAt?: string | null;
  licenseNo: string | null;
  licenseExpiry: string | null;
  basicSalaryMinor: number | null;
  bankAccount?: string | null;
  isActive: boolean;
}

export interface PersonRow {
  key: string;
  userId: string | null;
  employeeId: string | null;
  name: string;
  designation: string | null;
  department: string | null;
  branch: string | null;
  isDoctor: boolean;
  acceptsAppointments: boolean;
  roles: { id: string; code: string; name: string }[];
  employeeNo: string | null;
  contractType: string | null;
  isActive: boolean;
  username?: string | null;
  lockedUntil?: string | null;
}

export interface PersonPage {
  data: PersonRow[];
  nextCursor: string | null;
}

export interface PersonDetail {
  user: UserRow | null;
  employee: EmployeeRecord | null;
}

export interface Role {
  id: string;
  code: string;
  name: string;
  description: string | null;
  scope: string;
  isSystem: boolean;
  customized: boolean;
  require2fa: boolean;
  userCount: number;
  permissions: string[];
  modules: string[];
  groupModule?: string;
  state?: 'live' | 'archived' | 'off';
  standard?: string[] | null;
  added?: string[];
  removed?: string[];
  metadataDiffers?: boolean;
  removable?: boolean;
  updatedAt?: string;
}

export interface RoleGroup {
  module: string;
  label: string;
  state: 'live' | 'read_only';
  roles: Role[];
  available: { code: string; name: string; description: string; previouslyRemoved: boolean }[];
}

export interface PermissionGroup {
  group: string;
  module: string;
  moduleLabel?: string;
  state?: 'live' | 'read_only';
  permissions: { code: string; description: string; sensitive?: boolean; state?: 'live' | 'read_only' }[];
}

export const SUPER_ADMIN = 'super_admin';

export function holdsSuperAdmin(roles: readonly { code: string }[]): boolean {
  return roles.some((role) => role.code === SUPER_ADMIN);
}

export const PEOPLE_QUERY_KEY = ['people'] as const;
export const PERSON_QUERY_KEY = ['person'] as const;
